namespace Ir.Components.Workbook.Widgets._Html.WidgetHtml {
    interface IViewModel {
        config: WorkbookConfig;
        widget: IWidget;
        infoWidget: Array<{ name: string, value: string }>;
        suppressReportHeader: KnockoutObservable<boolean>;
    }

    interface IParams {
        config: WorkbookConfig;
        widget: IWidget;
    }

    export function getViewModel(this: IViewModel, params: IParams, componentInfo) {
        this.config = params.config as WorkbookConfig;
        this.widget = params.widget;
        this.suppressReportHeader = ko.observable(this.config.suppressReportHeader);

        let reportConfig = this.widget.itemConfig as ReportConfig;
        let result = this.widget.result as ReportWidgetResultVM;
        this.infoWidget = [];
        let dateNow = moment();
        this.infoWidget.push({ name: "Printed On:", value: `${dateNow.format(irSettings.shortDateTimeFormatForMoment)} by ${loggedUser.userName()}` });
        if (irSettings.multiTenant) {
            this.infoWidget.push({ name: "Company:", value: loggedUser.companyName() });
        }
        this.infoWidget.push({ name: "Mapping:", value: this.config.mappingName });
        this.infoWidget.push({ name: "Workbook:", value: this.config.workbookName });
        this.infoWidget.push({ name: "Tab:", value: replaceBasicHtmlContent((this.widget.tabOrWidget as WorkbookTab).name()) });

        let analyzeByName = reportConfig.analyzeByName();
        if (reportConfig.topBottom() !== TopBottomEnum.All) {       
            let metricField = reportConfig.getMetricField(reportConfig.topBottomFieldName());
            if (metricField) {
                analyzeByName += ` - ${TopBottomEnum[reportConfig.topBottom()]} ${reportConfig.resultCount()} by ${replaceBasicHtmlContent(metricField.displayName())}`
            }
        }
        this.infoWidget.push({ name: "Analyze By:", value: analyzeByName });

        let groupByName = reportConfig.groupByName();
        if (groupByName) {
            if (reportConfig.topBottomGroupBy() !== TopBottomEnum.All) {
                let metricField = reportConfig.getMetricField(reportConfig.topBottomGroupByFieldName());
                if (metricField) {
                    groupByName += ` - ${TopBottomEnum[reportConfig.topBottomGroupBy()]} ${reportConfig.resultCountGroupBy()} by ${replaceBasicHtmlContent(metricField.displayName())}`
                }
            }

            this.infoWidget.push({ name: "Group By:", value: groupByName });
        }

        let allFilters = [...result.filters];
        let workbookFilters = [...this.config.filters()].reverse();
        for (let workbookFilter of workbookFilters) {
            if (!allFilters.find(x => x.boundField() === workbookFilter.boundField())) {
                allFilters.unshift(workbookFilter);
            }
        }

        for (let filter of allFilters) {
            this.infoWidget.push({ name: `${filter.filterName()}${(filter.isMetric() ? "" : filter.conditionTypeIcon)}`, value: filter.startDisplayCondition() }); //testar o <br>
        }

        computedStyleToInlineStyle($("widget-html").get(0), {
            recursive: true,
            properties: ['font-size', 'font-weight'],
        });
    }
}